import { z } from 'zod';
import { optionalEmailFieldSchema } from '@/utils/validationRules';

const servicePageSchema = z.object({
  name: z.string(),
  icon: z.string().url().nullable(),
  image_src: z.string().url(),
  title: z.string(),
  description: z.string(),
}).passthrough();

const metricsSchema = z.object({
  CTM_Account_ID: z.string().optional().nullable(),
  CTM_FR_ID: z.string().optional().nullable(),
  CTM_REF_NUMBER: z.string().optional().nullable(),
  CTM_SWAP_NUMBER: z.string().optional().nullable(),
  GOOGLE_ADS_AW_CONVERSION_ID: z.string().optional().nullable(),
  GOOGLE_ANALYTICS_ID: z.string().optional().nullable(),
}).passthrough();

const countySchema = z.object({
  name: z.string(),
  FIPS: z.string(),
}).passthrough();

const locationsSchema = z.object({
  counties: z.array(countySchema).optional().nullable(),
}).passthrough();

const differentiatorGroupSchema = z.object({
  category: z.string(),
  icon: z.string().url(),
  differentiators: z.array(z.string()),
  visibility: z.string(), // e.g., "ALL_SERVICE", "SPECIFIC_SERVICE:SELECT"
  applicable_services: z.array(z.string()).optional().nullable(),
}).passthrough();

const promotionSchema = z.object({
  title: z.string(),
  details: z.string(),
}).passthrough();

const businessDataSchema = z.object({
  name: z.string(),
  logo_src: z.string().url().optional().nullable(),
  years_of_experience: z.string().optional().nullable(), // number as string
  email: optionalEmailFieldSchema.nullable(),
  locations: locationsSchema.optional().nullable(),
  differentiators: z.array(differentiatorGroupSchema).optional().nullable(),
  promotions: z.array(promotionSchema).optional().nullable(),
}).passthrough();

// Review object schema - assuming structure if reviews were present
const reviewSchema = z.object({
  text: z.string(),
  reviewer: z.string(),
  // Add other fields like rating, date if they exist
}).passthrough();

const lpConfigDataSchema = z.object({
  reviews: z.array(reviewSchema).optional().nullable(),
  services: z.record(servicePageSchema), // Keys are URL paths
  metrics: metricsSchema.optional().nullable(),
  business: businessDataSchema.optional().nullable(),
}).passthrough();

export const lpConfigSchema = z.object({
  timestamp: z.number(),
  data: lpConfigDataSchema,
}).passthrough();

export type LpConfig = z.infer<typeof lpConfigSchema>;
